<ng-container *ngIf="isLoading; else viewPrizes">
  <div fxLayout="column" fxLayoutAlign="center center" style="height: 100vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewPrizes>
  <div *ngFor="let module of modules">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="module-title-wrapper">
      <h3 class="font-lg font-bold spacing margin-0" >{{ module.sub_heading | uppercase }} </h3>
      <mat-divider class="width-100 border-top-width-3"></mat-divider>
    </div>

    <ng-container *ngIf="module.prizes; else elseTemplate">
      <div fxLayout="column" class="width-100" fxLayoutAlign.gt-sm="start start" fxLayoutAlign="center center" fxLayoutGap="48px">
        <ng-container *ngFor="let prize of module.prizes">
          <div class="width-100" fxLayout.gt-xs="row" fxLayout="column" fxLayoutGap.gt-xs="16px" fxLayoutGap="24px" *ngIf="prize">
            <div fxLayout.gt-xs="row" fxLayout="column" fxLayoutAlign.gt-sm="start start" fxLayoutAlign="center center">
              <uni-image
                [src]="prize.image"
                [default]="defaultImage"
                [alt]="prize.title"
                [height]="120"
                [width]="120"
                auxClassList="prize-img">
              </uni-image>
            </div>
            <div fxLayout="column" fxLayoutGap="8px" fxLayoutAlign.gt-xs="start start" fxLayoutAlign="center center">
              <h4 class="font-md font-bold margin-0 sparro-grey-900" >{{ prize.title }}</h4>
              <h5 class="font-md font-bold margin-0 sparro-grey-800">{{ prize.subtitle }}</h5>
              <h5 class="font-sm font-regular margin-0 award-desc sparro-grey-800" [ngClass.xs]="{'text-center': true}">{{ prize.desc }}</h5>
            </div>
          </div>
        </ng-container>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="module.desc" class="desc-wrapper">
        <div class="text-center font-sm sparro-grey-800" [innerHtml]="module.desc | safeContent"></div>
      </div>
    </ng-container>

    <ng-template #elseTemplate>
    </ng-template>
  </div>
</ng-template>
